import React, { useEffect } from 'react';
import { removeAuthData, removeUserPreferences } from '../common/localeStorageUtils';

import { routes } from '../routes';
import { useNavigate } from 'react-router-dom';

export default function SignUp() {
  const navigate = useNavigate();

  useEffect(() => {
    const authCode = new URLSearchParams(window.location.search).get('code');
    removeUserPreferences();
    if (authCode) {
      localStorage.setItem('stateFlow', JSON.stringify({ isSignUp: true }));
      navigate(`/${window.location.search}`, {
        state: {
          isSignUp: true,
          authCode,
        },
      });
    } else {
      removeAuthData();
      navigate(`${routes.TERMS_AND_CONDITIONS.path}${window.location.search}`, {
        state: { hasFooter: true },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
}
